import { Button, Flex, Image, Text } from "@fluentui/react-northstar";
import React from "react";
import Lottie from "react-lottie";

import * as animationData from "../../../assets/lotties/birthday.json";
import styled from "styled-components";
import LabelView from "../../../features/employee_folder/components/LabelView";
import IconBirthday from "../../../assets/icons/employee_folder/Birthday.svg";
import Card from "../Card/Card";
import BadgeBordered from "../../Badge/BadgeBordered";
import { DEVICE } from "../../../constants/responsive";

const CardContractDatesInfo = ({
    startAnimationConfetti = false,
    can_update = true,
    isCDI = false,
    day_number = null,
    month_text,
    year,
    seniority_text,
    moment_end_test_period,
    moment_end_contract,
    isMonthProBirthday = false,
    title = "",
    setModeUpdate = () => console.log("clicked to modify"),
    start_animation = () => console.log("clicked to start animation"),
    ...props
}) => {
    return (
        <Card {...props}>
            <Card.Body
                content={
                    <Flex gap="gap.medium" styles={{ flex: 1 }} fill column>
                        {startAnimationConfetti && (
                            <Lottie
                                options={{
                                    loop: false,
                                    autoplay: true,
                                    animationData: animationData,
                                    rendererSettings: {
                                        preserveAspectRatio: "xMidYMid slice",
                                    },
                                }}
                                height={"100vh"}
                                width={400}
                                style={{
                                    position: "absolute",
                                    inset: "0",
                                }}
                            />
                        )}
                        <Flex space="between">
                            <Flex vAlign="center" gap="gap.small">
                                <Title content={title} />
                                {isCDI && <BadgeBordered name={isCDI} />}
                            </Flex>
                            {can_update && (
                                <Button
                                    size="small"
                                    primary
                                    text
                                    content="Modifier"
                                    onClick={setModeUpdate}
                                />
                            )}
                        </Flex>
                        <Flex fill space="between" gap="gap.small">
                            <ResponsiveCell>
                                <Flex fill>
                                    <WrapperBeginDate column>
                                        <Day content={day_number} />
                                        <Month
                                            content={month_text + " " + year}
                                        />
                                    </WrapperBeginDate>
                                </Flex>
                                <Flex fill>
                                    <LabelView
                                        label="Ancienneté"
                                        content={seniority_text}
                                    />
                                    {isMonthProBirthday && (
                                        <Image
                                            src={IconBirthday}
                                            onClick={start_animation}
                                            styles={{ cursor: "pointer" }}
                                        />
                                    )}
                                </Flex>
                            </ResponsiveCell>
                        </Flex>
                        <ResponsiveCell>
                            <LabelView
                                label="Fin de période d’essai"
                                content={moment_end_test_period}
                            />
                            {moment_end_contract && (
                                <LabelView
                                    label="Fin de contrat"
                                    content={moment_end_contract}
                                />
                            )}
                        </ResponsiveCell>
                    </Flex>
                }
            />
        </Card>
    );
};

export default CardContractDatesInfo;

export const ResponsiveCell = styled(Flex)`
    justify-content: space-between;
    width: 100%;
    @media ${DEVICE.mobileS} {
        flex-direction: column;
        gap: 8px;
    }
    @media ${DEVICE.mobileM} {
        flex-direction: row;
    }
    @media ${DEVICE.mobileL} {
    }
`;

const Title = styled(Text)`
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;

    color: #242424;
`;

const Month = styled(Text)`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    color: #242424;
`;

const Day = styled(Text)`
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;

    color: #4f52b2;
`;

const WrapperBeginDate = styled(Flex)`
    background: #e8ebfa;
    border-radius: 2px;
    padding: 8px 12px;
    width: 120px;
`;
